import "./style.css"
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera, faPen, faQuestionCircle } from "@fortawesome/free-solid-svg-icons";


const ImageInput = ({ name, register, registerName, imageLoaded = null, nomeArquivo="" }) => {
    const [hasFileUploaded, setHasFileUploaded] = useState(false);
    const [editingImage, setEditingImage] = useState(null);
    const [currentFile, setCurrentFile] = useState(null);
    const [isPdf, setIsPdf] = useState(false);
    const [nomeArquivoAux, setNomeArquivoAux] = useState("");

    useEffect(() => {
        
        if (imageLoaded !== null && !hasFileUploaded) {

            if(nomeArquivo.trim() !== "") {
                verificaSeArquivoEhPdf(nomeArquivo);
            }

            setEditingImage(imageLoaded);
        }

    }, [imageLoaded, editingImage, hasFileUploaded, nomeArquivoAux]);

    const handleImageChange = (e) => {
        let target = e.target;
        let file = target.files ? target.files[0] : null;
        
        if (file === null) return;
        
        setEditingImage(null);
        verificaSeArquivoEhPdf(file.name);

        const url = URL.createObjectURL(file);
        setCurrentFile(url);
        setHasFileUploaded(true);
    }

    const verificaSeArquivoEhPdf = (nomeArquivo) => {
        let nomeArquivoSeparadoPorPonto = nomeArquivo.split('.');
        let extensaoArquivo = nomeArquivoSeparadoPorPonto.pop();

        if(extensaoArquivo === 'pdf') {
            setIsPdf(true);
            setNomeArquivoAux(nomeArquivo);
        } else {
            setIsPdf(false);
            setNomeArquivoAux("");
        }
    }

    return (
        <div className="input_box">
            <input type="file" id={name} className="ImageInput" {...register(registerName, { required: 'true' })} onChange={(e) => handleImageChange(e)} />
            <label htmlFor={name} >
                { hasFileUploaded || editingImage !== null ? (
                    <>
                        <div className="input_file_uploaded_image">
                            { editingImage !== null
                                ? ((isPdf) ? <p>Arquivo enviado em formato <strong>PDF</strong><FontAwesomeIcon title={nomeArquivoAux} style={{ marginLeft: "10px", width: "15px", height: "15px", cursor: "pointer"}} icon={faQuestionCircle} /></p> : <img src={`data:image/png;base64,${editingImage}`} id={`itemPreview${name}`} alt="uploaded foto"/>)
                                : ((isPdf) ? <p>Arquivo enviado em formato <strong>PDF</strong><FontAwesomeIcon title={nomeArquivoAux} style={{ marginLeft: "10px", width: "15px", height: "15px", cursor: "pointer"}} icon={faQuestionCircle} /></p> : <img src={currentFile ? currentFile : ""} alt="uploadfoto" />)
                            }
                            
                        </div>
                        <p className="input_file_uploaded_p">{name}</p>
                        <div className="input_file_uploaded_edit">
                            <div className="input_file_uploaded_edit_icon">
                                <FontAwesomeIcon icon={faPen} />
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <FontAwesomeIcon icon={faCamera} />
                        <p className="input_file_p">{name}</p>
                    </>
                ) }
                
            </label>
        </div>
    )
};

export { ImageInput };